/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconDocument = ({ className, height, width, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--document',
    className,
  )

  return (
    <IconBase className={classes} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20"{...rest}><g fill="none" fillRule="evenodd"><path className="fillpath" fill="#6D6D6D" fillRule="nonzero" d="M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2zm7 7V1.5L14.5 7H9z"/><path className="path2" d="M-4-2h24v24H-4z"/></g></IconBase>
  )
}

IconDocument.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
}

IconDocument.defaultProps = {
  height: 20,
  width: 16,
}

export default IconDocument
/* eslint-enable */
